import React from 'react';
import PropTypes from 'prop-types';

const CarinaCheck = ({ fill = 'currentColor', ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill={fill} viewBox="0 0 24 24" id="carina-check" {...props}>
        <path d="M20.7,5.3c0.4,0.4 0.4,1 0,1.4l-11,11c-0.2,0.2 -0.4,0.3 -0.7,0.3c-0.3,0 -0.5,-0.1 -0.7,-0.3l-5,-5c-0.4,-0.4 -0.4,-1 0,-1.4c0.4,-0.4 1,-0.4 1.4,0l4.3,4.3l10.3,-10.3c0.4,-0.4 1,-0.4 1.4,0" />
    </svg>
);

CarinaCheck.propTypes = {
    fill: PropTypes.string,
};

export default CarinaCheck;
